import { UntilDestroy } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AppConfig } from 'src/app/app.config';
import { Features } from 'src/app/models/features';
import { MatDialogRef } from '@angular/material/dialog';

@UntilDestroy()
@Component({
    selector: 'app-two-factor-authentication',
    templateUrl: './two-factor-authentication.component.html',
    styleUrls: ['./two-factor-authentication.component.scss']
})
export class TwoFactorAuthenticationComponent implements OnInit {
    signinTFAForm: UntypedFormGroup;
    tfaCode: UntypedFormControl;
    placeholderText = '';

    constructor(
        private dialogRef: MatDialogRef<TwoFactorAuthenticationComponent>,
        private appConfig: AppConfig
    ) { }

    ngOnInit() {
        this.tfaCode = new UntypedFormControl(null, [Validators.required]);
        this.signinTFAForm = new UntypedFormGroup({
            tfaCode: this.tfaCode
        });

        this.placeholderText = this.appConfig.getSection(Features.SIGN_IN) && !!this.appConfig.getSection(Features.SIGN_IN).TFAPlaceHolderText
            ? this.appConfig.getSection(Features.SIGN_IN).TFAPlaceHolderText
            : "Enter authorisation code";
    }

    submitTFA() {
        this.dialogRef.close(this.tfaCode.value);
    }
}
